import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocaleProvider } from './contexts/LocaleContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <LocaleProvider>
    <App />
  </LocaleProvider>
);

// パフォーマンスを測定する場合はコメントを解除
reportWebVitals();
